import { Stack, Typography } from "@mui/material";
import { Modal } from "Components/_Shared/BlModal";
import { Button } from "Components/_Shared/Buttons/Button";
import { Flex } from "Components/_Shared/Core/Flex";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

type Props = {
  readonly isOpen: boolean;
  readonly onConfirm: () => void;
  readonly onCancel: () => void;
  readonly title?: string;
  readonly text?: string;
};

export const ConfirmCloseDialog = ({ isOpen, onConfirm, onCancel, title, text }: Props) => {
  const { t } = useResource();

  return (
    <Modal open={isOpen} onClose={onCancel}>
      <Stack spacing={Spacing.XL} width={480} maxWidth="90vw" p={Spacing.XXL} borderRadius={Radius.XXXL} bgcolor="white" boxShadow={3}>
        <Typography variant="h2">{title ?? t(Resources.Common.ConfirmClose.Title)}</Typography>
        <Typography variant="body2" color="secondary">
          {text ?? t(Resources.Common.ConfirmClose.Text)}
        </Typography>
        <Flex justifyContent="flex-end" gap={Spacing.XL}>
          <Button color="secondary" onClick={onCancel}>
            {t(Resources.Common.ConfirmClose.Cancel)}
          </Button>
          <Button onClick={onConfirm}>{t(Resources.Common.ConfirmClose.Confirm)}</Button>
        </Flex>
      </Stack>
    </Modal>
  );
};
